function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.16 8.667v6.666c0 .92-.819 1.667-1.829 1.667H2.79C1.779 17 .96 16.254.96 15.333V8.667C.96 7.747 1.779 7 2.789 7H18.33c1.01 0 1.829.746 1.829 1.667zm.96.833h.96c.53 0 .96.373.96.833v3.334c0 .46-.43.833-.96.833h-.96v-5z",
    fill: "#000"
  }));
}

export var ReactComponent = SvgComponent;
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/location/ic-battery.svg";